/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TagIcon16Regular = forwardRef('TagIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.18 2a2.75 2.75 0 0 0-2.103.979L.761 5.729a2.75 2.75 0 0 0 0 3.542l2.316 2.75A2.75 2.75 0 0 0 5.18 13h7.07A2.75 2.75 0 0 0 15 10.25v-5.5A2.75 2.75 0 0 0 12.25 2H5.18Zm-.956 1.945A1.25 1.25 0 0 1 5.18 3.5h7.07c.69 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25H5.18a1.25 1.25 0 0 1-.956-.445L1.91 8.305a1.25 1.25 0 0 1 0-1.61l2.315-2.75Z" })));
});
